import { useEffect, useRef } from 'react';
export const useTimeout = (callback, delay) => {
    const savedCallback = useRef(callback);
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        const id = setTimeout(() => savedCallback.current(), delay);
        return () => clearTimeout(id);
    }, [delay]);
};
//# sourceMappingURL=index.js.map